<ng-container *transloco="let t">
  <div class="container">
    <div class="d-flex justify-content-center align-items-center w-100 h-100">
      <h1 class="heading-size-5">{{ t('ansok_pdf_loading') }}</h1>
      <div class="loader"></div>
    </div>
  </div>
</ng-container>
